import { handledGetFetch } from '../../submodules/shared/utils/api-base';

import { PATHS } from './paths';
import { buildUrl } from './url';

export const getEventProducts = (eventId) => handledGetFetch(buildUrl(PATHS.event(eventId)));
